import { defaultSystem } from '@chakra-ui/react';

const appColors = {
  mainBg: 'rgb(4,5,6)',
  hover: 'rgba(66,153,225,0.8)',
  primary: 'rgb(66,153,225)',
};

const theme = defaultSystem;

export { appColors, theme };
